module.exports = __webpack_public_path__ + "media/country_flags/pn-f5a09cb2.png";